import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30f572c3")

_pushScopeId("data-v-30f572c3")
const _hoisted_1 = {
  "data-testid": "pickup-schedule-config-section-regular-schedule",
  class: "overflow-visible rounded-xl border border-gray-lp-1600"
}
const _hoisted_2 = { class: "flex items-center px-3 py-2.5" }
const _hoisted_3 = { class: "ml-2 flex items-center gap-1.5" }
const _hoisted_4 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_5 = {
  key: 0,
  class: "absolute bottom-full left-1/2 z-50 mb-2 w-64 -translate-x-1/2 rounded-md bg-white p-3 text-12px font-normal font-montserrat shadow-lg"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DayScheduleRow = _resolveComponent("DayScheduleRow")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ToggleV2, {
        modelValue: _ctx.enabledValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.enabledValue = $event)),
        "data-testid": "pickup-schedule-config-toggle-regular-schedule",
        class: "regular-toggle",
        disabled: _ctx.loading,
        styleActive: "schedule-active-background"
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.title")), 1),
        _createVNode("div", {
          class: "relative inline-flex items-center",
          "data-testid": "pickup-schedule-config-tooltip-regular-schedule",
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isActiveTooltip = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isActiveTooltip = false))
        }, [
          _createVNode("img", {
            src: 
              require(`@/app/ui/assets/svg/${
                _ctx.isActiveTooltip ? 'info-red' : 'info'
              }.svg`)
            ,
            class: "h-4 w-4 cursor-pointer",
            alt: ""
          }, null, 8, ["src"]),
          (_ctx.isActiveTooltip)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.tooltip")), 1))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(7, (row) => {
          return _createVNode("div", {
            key: row,
            class: "border-t border-gray-lp-1600 px-3 py-3"
          }, [
            _createVNode(_component_Skeleton, {
              height: "32px",
              width: "100%"
            })
          ])
        }), 64))
      : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.normalizedDays, (schedule) => {
          return (_openBlock(), _createBlock(_component_DayScheduleRow, {
            key: schedule.day,
            day: schedule.day,
            dayLabel: _ctx.$t(`pickup.scheduleConfig.regular.days.${schedule.day}`),
            checked: schedule.checked,
            slots: schedule.slots,
            enabled: _ctx.enabled,
            popoverOpen: _ctx.openDay === schedule.day,
            slotStartHour: _ctx.slotStartHour,
            slotEndHour: _ctx.slotEndHour,
            slotIntervalMinutes: _ctx.slotIntervalMinutes,
            "onUpdate:checked": ($event: any) => (_ctx.updateChecked(schedule.day, $event)),
            "onUpdate:slots": ($event: any) => (_ctx.updateSlots(schedule.day, $event)),
            onOpenAddTime: ($event: any) => (_ctx.toggleDay(schedule.day)),
            onClosePopover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDay = ''))
          }, null, 8, ["day", "dayLabel", "checked", "slots", "enabled", "popoverOpen", "slotStartHour", "slotEndHour", "slotIntervalMinutes", "onUpdate:checked", "onUpdate:slots", "onOpenAddTime"]))
        }), 128))
  ]))
})